import { all, put, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../requests';

export function* listCombos(action) {
  try {
    const response = yield API.listCombos(action.payload);
    yield put({
      type: ActionTypes.COMBOS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBOS_FAILURE,
    });
  }
}

export function* listFilterCombo(action) {
  try {
    const response = yield API.listFilterCombo(action.payload);
    var comboType = action.payload.comboTypes;
    var filterComboType = 'Filter_' + comboType;
    var filterBy = action.payload.filterBy;
    var filterResponse = {
      [filterComboType]: { [filterBy]: response.data.data[comboType] },
      mapper: filterComboType,
    };
    yield put({
      type: ActionTypes.FILTER_COMBO_SUCCESS,
      payload: filterResponse,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBOS_FAILURE,
    });
  }
}

export function* listSmartCombos(action) {
  try {
    const response = yield API.listSmartCombos(action.payload);
    yield put({
      type: ActionTypes.COMBOS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBOS_FAILURE,
    });
  }
}

export function* listFullCombos(action) {
  try {
    const response = yield API.listCombos(action.payload);
    yield put({
      type: 'COMBOS_FULL_SUCCESS',
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBOS_FAILURE,
    });
  }
}
export function* listMobileAppRoleGet(action) {
  try {
    const response = yield API.listMobileAppRoleGet(action.payload);
    yield put({
      type: ActionTypes.GET_LIST_MOBILE_APP_ROLE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.GET_LIST_MOBILE_APP_ROLE_FAILURE,
    });
  }
}
export function* spListCombos(action) {
  try {
    const response = yield API.spListCombos(action.payload);
    yield put({
      type: ActionTypes.SP_LIST_COMBOS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.SP_LIST_COMBOS_FAILURE,
    });
  }
}
export function* addNoteType(action) {
  try {
    const response = yield API.addNoteType(action.payload);
    yield put({
      type: ActionTypes.ADD_NOTE_TYPE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.ADD_NOTE_TYPE_FAILURE,
    });
  }
}
export function* getDynamicComos(action) {
  try {
    const response = yield API.getDynamicComos(action.payload);
    yield put({
      type: ActionTypes.COMBOS_DYNAMIC_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBOS_DYNAMIC_FAILURE,
    });
  }
}
export function* medicateCombos(action) {
  try {
    const response = yield API.medicateCombos(action.payload);
    yield put({
      type: ActionTypes.COMBOS_MEDICATE_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBOS_MEDICATE_FAILURE,
    });
  }
}
export function* getDiagnosis(action) {
  try {
    const response = yield API.getDiagnosis(action.payload);
    yield put({
      type: ActionTypes.GET_DIAGNOSIS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.GET_DIAGNOSIS_FAILURE,
    });
  }
}
export function* getDiagnosisCode(action) {
  try {
    const response = yield API.getDiagnosisCode(action.payload);
    yield put({
      type: ActionTypes.GET_DIAGNOSIS_CODE_SUCCESS,
      payload: JSON.parse(response.data.data)[0],
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.GET_DIAGNOSIS_CODE_FAILURE,
    });
  }
}
export function* comboPlaceOfService(action) {
  try {
    const response = yield API.comboPlaceOfService(action.payload);
    yield put({
      type: ActionTypes.COMBO_PLACE_OF_SERVICE_SUCCESS,
      payload: JSON.parse(response.data.data)[0],
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBO_PLACE_OF_SERVICE_FAILURE,
    });
  }
}
export function* comboDiagnosisList(action) {
  try {
    const response = yield API.comboDiagnosisList(action.payload);
    yield put({
      type: ActionTypes.COMBO_DIAGNOSIS_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBO_DIAGNOSIS_LIST_FAILURE,
    });
  }
}
export function* comboSupervisor(action) {
  try {
    const response = yield API.comboSupervisor(action.payload);
    yield put({
      type: ActionTypes.COMBO_SUPERVISOR_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.COMBO_SUPERVISOR_FAILURE,
    });
  }
}

export default function* root() {
  yield all([takeLatest(ActionTypes.SMARTCOMBOS_REQUEST, listSmartCombos)]);
  yield all([takeLatest(ActionTypes.COMBOS_REQUEST, listCombos)]);
  yield all([takeLatest(ActionTypes.FILTER_COMBO_REQUEST, listFilterCombo)]);
  yield all([takeLatest('COMBOS_FULL_REQUEST', listFullCombos)]);
  yield all([takeLatest(ActionTypes.SP_LIST_COMBOS_REQUEST, spListCombos)]);
  yield all([takeLatest(ActionTypes.GET_LIST_MOBILE_APP_ROLE_REQUEST, listMobileAppRoleGet)]);
  yield all([takeLatest(ActionTypes.ADD_NOTE_TYPE_REQUEST, addNoteType)]);
  yield all([takeLatest(ActionTypes.COMBOS_DYNAMIC_REQUEST, getDynamicComos)]);
  yield all([takeLatest(ActionTypes.COMBOS_MEDICATE_REQUEST, medicateCombos)]);
  yield all([takeLatest(ActionTypes.GET_DIAGNOSIS_REQUEST, getDiagnosis)]);
  yield all([takeLatest(ActionTypes.GET_DIAGNOSIS_CODE_REQUEST, getDiagnosisCode)]);
  yield all([takeLatest(ActionTypes.COMBO_PLACE_OF_SERVICE_REQUEST, comboPlaceOfService)]);
  yield all([takeLatest(ActionTypes.COMBO_DIAGNOSIS_LIST_REQUEST, comboDiagnosisList)]);
  yield all([takeLatest(ActionTypes.COMBO_SUPERVISOR_REQUEST, comboSupervisor)]);
}
